/* RubyGator mobile menu: tapping the name of a top-level item that has a submenu (for example "Pokémon")
   opens that submenu, the same as tapping its arrow, instead of going to the item's collection page.
   Only applies while the arrow (.open-children-toggle) is visible, which is the mobile menu; desktop is unchanged. */
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('li.level0.bls__menu-parent > a') : null;
    if (!link) return;
    var toggle = link.parentElement.querySelector(':scope > .open-children-toggle');
    if (!toggle || !toggle.offsetWidth || !toggle.offsetHeight) return;
    event.preventDefault();
    event.stopPropagation();
    toggle.click();
  }, true);
})();
